// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__vZ3Ds","content":"app_content__2licF","detail":"app_detail__390Qz","list":"app_list__1jV_d"};